import Invoice3Container from "../../../../components/applications/eCommerce/invoices/invoice3";

const Invoice3 = () => {
  return <Invoice3Container />;
};

export default Invoice3;
